/* section-product.js - PDP interactions */
(function () {
  'use strict';

  const product       = window.__bfProduct || {};
  const variants      = product.variants || [];
  const variantPrices = product.variantPrices || {};

  // ── Utility ──────────────────────────────────────────────────────────────

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  // Resolved early so functions called during initial setup (onVariantChange) can safely reference it
  const galleryMain = $('[data-gallery-main]');

  function shopifyResizeUrl(src, size) {
    if (!src) return '';
    const parts = src.split('?');
    const base = parts[0].replace(/(\.(?:jpg|jpeg|png|gif|webp))$/i, `_${size}x${size}$1`);
    return parts[1] ? `${base}?${parts[1]}` : base;
  }

  // ── Variant selection ─────────────────────────────────────────────────────

  function getSelectedOptions() {
    const result = [];
    $$('[data-variant-option]').forEach(input => {
      if (input.type === 'radio' && input.checked) {
        result[+input.dataset.variantOption] = input.value;
      }
    });
    return result;
  }

  function findVariant(options) {
    return variants.find(v =>
      v.options.every((opt, i) => opt === options[i])
    ) || null;
  }

  // Resolve the server-rendered, Markets-aware formatted price for a
  // given variant. Falls back to whatever Liquid put in the DOM if the
  // map is missing (shouldn't happen, but keeps the UI from wiping the
  // price on a malformed product object).
  function priceFor(variant) {
    const entry = variantPrices[variant.id] || {};
    return {
      price: entry.price || '',
      compare_at_price: entry.compare_at_price || ''
    };
  }

  function updatePrice(variant) {
    const wrap = $('[data-price-wrap]');
    if (!wrap || !variant) return;
    const regular = wrap.querySelector('.price__regular');
    const sale    = wrap.querySelector('.price__sale');
    const compare = wrap.querySelector('.price__compare');
    const formatted = priceFor(variant);

    if (variant.compare_at_price > variant.price) {
      if (sale)    { sale.textContent = formatted.price; sale.style.display = ''; }
      if (compare) { compare.textContent = formatted.compare_at_price; compare.style.display = ''; }
      if (regular) regular.style.display = 'none';
    } else {
      if (sale)    sale.style.display = 'none';
      if (compare) compare.style.display = 'none';
      if (regular) { regular.textContent = formatted.price; regular.style.display = ''; }
    }

    updateBoniPoints(variant.price);
  }

  function updateBoniPoints(priceCents) {
    // Mirrors snippets/boni-points-line.liquid: floor(€) × 10.
    const pts = Math.floor(priceCents / 100) * 10;
    document.querySelectorAll('[data-pdp] [data-boni-points]').forEach(el => {
      el.textContent = pts;
    });
  }

  function updateStock(variant) {
    if (!variant) return;
    // Use Liquid-injected inventory map for accurate counts
    const invMap = product.inventory || {};
    const qty = invMap[variant.id] !== undefined ? invMap[variant.id] : (variant.inventory_quantity || 0);

    $$('.stock-indicator').forEach(el => {
      const label = el.querySelector('.stock-indicator__label');
      if (!variant.available) {
        el.className = 'stock-indicator stock-indicator--out-of-stock';
        if (label) label.textContent = bfT('sold_out', 'Ausverkauft');
      } else if (qty > 0 && qty <= 3) {
        el.className = 'stock-indicator stock-indicator--low-stock';
        if (label) label.textContent = bfT('only_n_left', 'Nur noch %%N%% verfügbar').replace('%%N%%', qty);
      } else {
        el.className = 'stock-indicator stock-indicator--in-stock';
        if (label) label.textContent = qty > 0 ? bfT('in_stock_plain', 'Auf Lager') + ' · ' + qty : bfT('stock_in', 'Lieferbar');
      }
    });
  }

  function updateAtcButton(variant) {
    const available = variant && variant.available;
    $$('[data-atc-btn], [data-sticky-atc]').forEach(b => {
      b.disabled = !available;
      if (!b.dataset.updating) {
        b.textContent = available ? bfT('add_to_cart', 'In den Warenkorb') : bfT('sold_out', 'Ausverkauft');
      }
    });

    const notifyWrap = $('[data-notify-wrap]');
    const variantInput = $('[data-notify-variant]');
    if (notifyWrap) {
      notifyWrap.hidden = !!available;
      if (variantInput && variant) variantInput.value = variant.id;
    }
  }

  function updateVariantId(variant) {
    const input = $('[data-variant-id]');
    if (input && variant) input.value = variant.id;
  }

  function updateBadge(variant) {
    const badge = $('[data-gallery-badge]');
    if (!badge) return;
    const label = variant && variant.title !== 'Default Title' ? variant.title : '';
    badge.textContent = label;
    badge.hidden = !label;
  }

  function updateStickyBar(variant) {
    const stickyVariant = $('[data-sticky-variant]');
    const stickyStock   = $('[data-sticky-stock]');
    const stickyImg     = $('[data-sticky-img]');
    const stickyPrice   = $('[data-sticky-price]');

    // Variant chip: show only when product has multiple variants. Empty
    // text collapses the chip via :empty, so the line reads price-only
    // for default-variant products.
    if (stickyVariant && variant) {
      const hasOptions = stickyVariant.dataset.hasVariant === '1';
      stickyVariant.textContent = (hasOptions && variant.title && variant.title !== 'Default Title')
        ? variant.title
        : '';
    }

    if (stickyPrice && variant) {
      stickyPrice.textContent = priceFor(variant).price;
    }

    // Stock: only render text on low/out-of-stock states. In-stock is
    // implicit (the ATC button is enabled), and adding "Auf Lager" on
    // every product would noise up the bar on the cramped mobile layout.
    if (stickyStock && variant) {
      const invMap = product.inventory || {};
      const qty = invMap[variant.id] !== undefined ? invMap[variant.id] : (variant.inventory_quantity || 0);
      if (!variant.available) {
        stickyStock.textContent = bfT('sold_out', 'Ausverkauft');
        stickyStock.dataset.status = 'out';
      } else if (qty > 0 && qty <= 3) {
        stickyStock.textContent = 'Nur ' + qty;
        stickyStock.dataset.status = 'low';
      } else {
        stickyStock.textContent = '';
        delete stickyStock.dataset.status;
      }
    }

    if (stickyImg && variant && variant.featured_image) {
      const src = shopifyResizeUrl(variant.featured_image.src, 80);
      const existing = stickyImg.querySelector('img');
      if (!existing || existing.src !== src) {
        stickyImg.innerHTML = `<img src="${src}" alt="" width="44" height="44" loading="eager" decoding="async">`;
      }
    }
  }

  // Build the keys ("option-handle_value-handle") that identify the
  // currently-selected variant for matching against alt-text directives.
  function variantKeys(variant) {
    const handles = (window.__bfProduct && window.__bfProduct.optionHandles) || [];
    const keys = [];
    (variant.options || []).forEach((val, idx) => {
      const optHandle = handles[idx];
      if (!optHandle) return;
      const valHandle = String(val).toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      keys.push(optHandle + '_' + valHandle);
    });
    return keys;
  }

  // Matches a comma-separated alt-text `#`-directive against the active
  // variant's option/value keys. Empty directive = no opinion (null).
  function matchesDirective(directive, keys, locale) {
    if (!directive) return null;
    return directive.split(',').some(raw => {
      let clean = raw.trim();
      const colonIdx = clean.indexOf(':');
      if (colonIdx > 0 && colonIdx < 6) {
        const prefix = clean.slice(0, colonIdx);
        if (prefix !== locale) return false;
        clean = clean.slice(colonIdx + 1);
      }
      return keys.indexOf(clean) !== -1;
    });
  }

  // Matches the native Shopify variant attachment list. Empty = no opinion.
  function matchesVariantList(list, variantId) {
    if (!list) return null;
    return list.split(',').some(id => Number(id) === Number(variantId));
  }

  // Decide visibility for one element. If the image has neither marker
  // (native attachment nor directive), it's a default and always visible.
  // Otherwise, it must match via at least one present marker.
  function isVisibleForVariant(el, variant, keys, locale) {
    const variantHit = matchesVariantList(el.dataset.imageVariants || '', variant.id);
    const directiveHit = matchesDirective(el.dataset.gangConnect || '', keys, locale);
    if (variantHit === null && directiveHit === null) return true;
    return variantHit === true || directiveHit === true;
  }

  function updateGalleryForVariant(variant, instant) {
    if (!variant) return;
    const locale = (window.__bfProduct && window.__bfProduct.locale) || 'de';
    const keys = variantKeys(variant);

    let firstVisibleIndex = null;
    $$('[data-gallery-slide]').forEach((slide, idx) => {
      const visible = isVisibleForVariant(slide, variant, keys, locale);
      slide.hidden = !visible;
      if (visible && firstVisibleIndex === null) firstVisibleIndex = idx;
    });
    $$('[data-gallery-thumb]').forEach(t => {
      t.hidden = !isVisibleForVariant(t, variant, keys, locale);
    });
    $$('[data-gallery-dot]').forEach(d => {
      d.hidden = !isVisibleForVariant(d, variant, keys, locale);
    });

    // Prefer the variant's featured_image when it's still visible;
    // otherwise activate the first visible slide.
    let targetIdx = firstVisibleIndex;
    if (variant.featured_image) {
      const featured = $(`[data-image-id="${variant.featured_image.id}"]`);
      if (featured && !featured.hidden) targetIdx = +featured.dataset.gallerySlide;
    }
    if (targetIdx !== null) activateGallerySlide(targetIdx, true, false, instant);
  }

  function onVariantChange() {
    const options = getSelectedOptions();
    const variant = findVariant(options);
    if (!variant) return;
    $$('[data-variant-option]').forEach(input => {
      if (input.type !== 'radio') return;
      const label = input.closest('label');
      if (label) label.classList.toggle('is-selected', input.checked);
    });
    updatePrice(variant);
    updateStock(variant);
    updateAtcButton(variant);
    updateVariantId(variant);
    updateBadge(variant);
    updateStickyBar(variant);
    updateGalleryForVariant(variant);
    // Public hook: lets other PDP modules (e.g. pdp-pairings.js) react to
    // variant changes without monkey-patching this function.
    document.dispatchEvent(new CustomEvent('boni:variant:changed', { detail: { variantId: variant.id, variant } }));
  }

  $$('[data-variant-option]').forEach(input => {
    input.addEventListener('change', onVariantChange);
  });
  onVariantChange(); // set initial state

  // Mobile: the swipe carousel can't be positioned until it has layout, and
  // the initial scroll must JUMP straight to the selected variant's image
  // rather than the always-first generic cover image. Re-assert it after the
  // first frame, instantly.
  requestAnimationFrame(() => {
    const v = findVariant(getSelectedOptions());
    if (v) updateGalleryForVariant(v, true);
  });

  // ── Gallery ───────────────────────────────────────────────────────────────

  function playTileTransition(slide) {
    if (!slide) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const img = slide.querySelector('img');
    if (!img) return;
    const src = img.currentSrc || img.src;
    const old = slide.querySelector('.pdp__tile-overlay');
    if (old) old.remove();

    // Hide the underlying image while the tile mosaic plays so the
    // animation is visible. Restored when the overlay is removed.
    img.style.visibility = 'hidden';

    const overlay = document.createElement('div');
    overlay.className = 'pdp__tile-overlay';
    for (let r = 0; r < 3; r++) {
      for (let c = 0; c < 3; c++) {
        const t = document.createElement('div');
        t.className = 'pdp__tile-overlay__tile';
        t.style.left   = `${(c * 100) / 3}%`;
        t.style.top    = `${(r * 100) / 3}%`;
        t.style.width  = `${100 / 3}%`;
        t.style.height = `${100 / 3}%`;
        t.style.backgroundImage = `url(${src})`;
        t.style.backgroundSize = '300% 300%';
        t.style.backgroundPosition = `${(c * 100) / 2}% ${(r * 100) / 2}%`;
        t.style.transitionDelay = `${(r * 3 + c) * 80}ms`;
        overlay.appendChild(t);
      }
    }
    slide.appendChild(overlay);
    requestAnimationFrame(() => {
      overlay.classList.add('is-revealing');
      // Last tile lands at ~700ms transform + 8 * 80ms stagger = ~1340ms.
      // Reveal the underlying image first, then remove the overlay so the
      // tile-to-image handoff is seamless.
      setTimeout(() => { img.style.visibility = ''; }, 1350);
      setTimeout(() => overlay.remove(), 1450);
    });
  }

  // Active-state visuals only (slides/thumbs/dots) — no scrolling, no
  // reverse-sync. Shared by variant-driven activation and the mobile swipe
  // handler so the indicator classes live in one place.
  function setActiveSlide(idx) {
    $$('[data-gallery-slide]').forEach(slide => {
      slide.classList.toggle('is-active', +slide.dataset.gallerySlide === idx);
    });
    $$('[data-gallery-thumb]').forEach(thumb => {
      const active = +thumb.dataset.galleryThumb === idx;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', String(active));
    });
    $$('[data-gallery-dot]').forEach(dot => {
      dot.classList.toggle('is-active', +dot.dataset.galleryDot === idx);
    });
  }

  // Slides currently shown for the active variant. Hidden (non-matching)
  // slides collapse to zero width in the mobile flex carousel, so any
  // index↔pixel math must use this list, not the global slide order.
  function visibleSlides() {
    return $$('[data-gallery-slide]').filter(s => !s.hidden);
  }

  // Scroll the mobile carousel so slide `idx` is in view. The offset is the
  // slide's index AMONG VISIBLE slides — hidden slides collapse to zero width
  // in the flex carousel, so the global index would overshoot. No-op on
  // desktop (main has no overflow). Returns true if it handled the scroll.
  //   smooth — animate vs. jump (jump for the initial positioning).
  function scrollCarouselToSlide(idx, smooth) {
    if (!galleryMain || galleryMain.scrollWidth <= galleryMain.clientWidth) return false;
    const targetSlide = $(`[data-gallery-slide="${idx}"]`);
    if (!targetSlide || targetSlide.hidden) return false;
    const pos = Math.max(0, visibleSlides().indexOf(targetSlide));
    const left = pos * galleryMain.offsetWidth;
    if (Math.abs(galleryMain.scrollLeft - left) > 1) {
      galleryMain.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
    }
    return true;
  }

  // Gallery navigation NEVER changes the selected variant — the swatches own
  // that. The gallery only ever shows the current variant's images plus the
  // generic cover, so swiping/arrowing just moves between those.
  function activateGallerySlide(idx, fromVariant, playTransition, instant) {
    const previousActive = $('[data-gallery-slide].is-active');
    setActiveSlide(idx);

    if (playTransition && !fromVariant) {
      const newSlide = $(`[data-gallery-slide="${idx}"]`);
      if (newSlide && newSlide !== previousActive) playTileTransition(newSlide);
    }

    // Mobile: bring the slide into view (no-op on desktop).
    if (fromVariant) scrollCarouselToSlide(idx, !instant);
  }

  // Desktop: thumbnail clicks
  $$('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => activateGallerySlide(+thumb.dataset.galleryThumb, false, true));
  });

  // Mobile: dot clicks scroll the carousel
  $$('[data-gallery-dot]').forEach(dot => {
    dot.addEventListener('click', () => {
      if (!galleryMain) return;
      const idx = +dot.dataset.galleryDot;
      galleryMain.scrollTo({ left: idx * galleryMain.offsetWidth, behavior: 'smooth' });
      activateGallerySlide(idx, false, true);
    });
  });

  // Arrow buttons (prev/next)
  const galPrev = $('[data-gallery-prev]');
  const galNext = $('[data-gallery-next]');

  function goSlide(dir) {
    const vis = visibleSlides();
    if (!vis.length) return;
    // Current position among VISIBLE slides (is-active tracks the scroll
    // position on mobile, the active slide on desktop).
    let curPos = vis.findIndex(s => s.classList.contains('is-active'));
    if (curPos === -1) curPos = 0;
    const nextSlide = vis[(curPos + dir + vis.length) % vis.length];
    const idx = +nextSlide.dataset.gallerySlide;
    // Mobile: scroll the carousel. Desktop: swap the active slide (+transition).
    if (scrollCarouselToSlide(idx, true)) {
      setActiveSlide(idx);
    } else {
      activateGallerySlide(idx, false, true);
    }
  }
  if (galPrev) galPrev.addEventListener('click', () => goSlide(-1));
  if (galNext) galNext.addEventListener('click', () => goSlide(1));

  // Keyboard navigation
  if (galleryMain) {
    galleryMain.setAttribute('tabindex', '0');
    galleryMain.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goSlide(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(1); }
    });
  }

  // ── Lightbox (click-to-zoom) ─────────────────────────────────────────────
  const lightbox = $('[data-lightbox]');
  if (lightbox && window.__bfProduct && Array.isArray(window.__bfProduct.images)) {
    const lbImg     = $('[data-lightbox-img]', lightbox);
    const lbCounter = $('[data-lightbox-counter]', lightbox);
    const lbClose   = $('[data-lightbox-close]', lightbox);
    const lbPrev    = $('[data-lightbox-prev]', lightbox);
    const lbNext    = $('[data-lightbox-next]', lightbox);
    const images    = window.__bfProduct.images;
    let lbIdx = 0;
    let lastFocus = null;

    function buildSrc(img) {
      // image objects from {{ product.images | json }} carry { src, alt, width, height }
      if (!img) return '';
      if (typeof img === 'string') return img;
      const src = img.src || '';
      // Replace any size suffix with _2048x for lightbox; works whether src has one or not
      return src.replace(/(\.[a-z]+)(\?.*)?$/, '_2048x$1$2');
    }

    function renderLb() {
      const img = images[lbIdx];
      if (!img) return;
      lbImg.src = buildSrc(img);
      lbImg.alt = img.alt || '';
      if (lbCounter) lbCounter.textContent = `${lbIdx + 1} / ${images.length}`;
      if (lbPrev) lbPrev.disabled = images.length < 2;
      if (lbNext) lbNext.disabled = images.length < 2;
    }

    function openLb(idx) {
      lbIdx = Math.max(0, Math.min(idx, images.length - 1));
      lastFocus = document.activeElement;
      lightbox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      renderLb();
      requestAnimationFrame(() => lbClose && lbClose.focus());
    }
    function closeLb() {
      lightbox.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    function stepLb(dir) {
      lbIdx = (lbIdx + dir + images.length) % images.length;
      renderLb();
    }

    if (galleryMain) {
      galleryMain.style.cursor = 'zoom-in';
      galleryMain.addEventListener('click', e => {
        // Don't hijack arrow clicks (they're outside galleryMain) or thumb clicks
        const slide = e.target.closest('[data-gallery-slide]');
        if (!slide) return;
        openLb(+slide.dataset.gallerySlide || 0);
      });
    }
    if (lbClose) lbClose.addEventListener('click', closeLb);
    if (lbPrev)  lbPrev.addEventListener('click', () => stepLb(-1));
    if (lbNext)  lbNext.addEventListener('click', () => stepLb(1));
    lightbox.addEventListener('click', e => {
      // Click on backdrop (the dialog itself) closes; clicks on stage/img/buttons don't bubble close
      if (e.target === lightbox) closeLb();
    });
    document.addEventListener('keydown', e => {
      if (lightbox.hidden) return;
      if (e.key === 'Escape')     { e.preventDefault(); closeLb(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); stepLb(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); stepLb(1); }
    });
  }

  // Mobile: keep the active dot/thumb in sync as the user swipes. Maps the
  // scroll position to an index among VISIBLE slides. Does not touch the
  // variant — the gallery never drives variant selection.
  if (galleryMain) {
    let scrollTimer;
    galleryMain.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const vis = visibleSlides();
        if (!vis.length) return;
        const pos = Math.round(galleryMain.scrollLeft / galleryMain.offsetWidth);
        const slide = vis[Math.max(0, Math.min(pos, vis.length - 1))];
        if (slide) setActiveSlide(+slide.dataset.gallerySlide);
      }, 80);
    }, { passive: true });
  }

  // ── Quantity widget ───────────────────────────────────────────────────────

  const mainQtyInput    = $('#pdp-qty');
  const stickyQtyInput  = $('[data-sticky-qty-input]');

  // Stock cap: whenever Shopify is tracking the variant, qty can't exceed
  // inventory_quantity (and we subtract whatever is already in the cart
  // for the same variant). Policy ("deny" vs. "continue") is intentionally
  // ignored — the user wants a hard cap on actual stock regardless of
  // whether Shopify itself would still accept the order.
  let stockMax = 99;
  let inCartForVariant = 0;

  function getCurrentVariant() {
    const idEl = $('[data-variant-id]');
    const id = idEl ? +idEl.value : 0;
    return variants.find(v => v.id === id) || null;
  }

  function isTracked(v) {
    // `inventory_management` is "shopify" (or another tracker) when on,
    // null/empty when off. The tracker name itself doesn't matter.
    return v && v.inventory_management != null && v.inventory_management !== '';
  }

  function recomputeStockMax() {
    const v = getCurrentVariant();
    if (!v || !isTracked(v)) { stockMax = 99; }
    else {
      const inv = (product.inventory || {})[v.id];
      const stock = (inv !== undefined ? inv : (v.inventory_quantity || 0));
      stockMax = Math.max(0, stock - inCartForVariant);
    }
    if (mainQtyInput)   mainQtyInput.max   = String(stockMax || 1);
    if (stickyQtyInput) stickyQtyInput.max = String(stockMax || 1);

    // Disable ATC + Shop Pay when nothing left to add.
    const atOrOverCap = stockMax <= 0 && v && v.available;
    $$('[data-atc-btn], [data-sticky-atc]').forEach(b => {
      if (atOrOverCap && !b.dataset.updating) {
        b.disabled = true;
        b.dataset.stockBlocked = '1';
        b.textContent = bfT('maximized_in_cart', 'Im Warenkorb maximiert');
      } else if (b.dataset.stockBlocked === '1' && !atOrOverCap) {
        b.disabled = !v || !v.available;
        delete b.dataset.stockBlocked;
        b.textContent = (v && v.available) ? bfT('add_to_cart', 'In den Warenkorb') : bfT('sold_out', 'Ausverkauft');
      }
    });

    syncQty(+mainQtyInput?.value || 1);
  }

  // Refresh the in-cart count for the current variant; called on init and
  // after an add-to-cart succeeds. Best-effort — failures fall back to 0.
  function refreshInCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : null)
      .then(cart => {
        const v = getCurrentVariant();
        if (!cart || !v) { inCartForVariant = 0; recomputeStockMax(); return; }
        let n = 0;
        (cart.items || []).forEach(it => { if (it.variant_id === v.id) n += it.quantity; });
        inCartForVariant = n;
        recomputeStockMax();
      })
      .catch(() => { inCartForVariant = 0; recomputeStockMax(); });
  }

  function syncQty(val) {
    const cap = stockMax > 0 ? stockMax : 1;
    const n = Math.min(cap, Math.max(1, parseInt(val, 10) || 1));
    if (mainQtyInput   && +mainQtyInput.value   !== n) mainQtyInput.value   = n;
    if (stickyQtyInput && +stickyQtyInput.value !== n) stickyQtyInput.value = n;
  }

  const decBtn = $('[data-qty-dec]');
  const incBtn = $('[data-qty-inc]');
  if (decBtn) decBtn.addEventListener('click', () => syncQty((+mainQtyInput?.value || 1) - 1));
  if (incBtn) incBtn.addEventListener('click', () => syncQty((+mainQtyInput?.value || 1) + 1));
  if (mainQtyInput) mainQtyInput.addEventListener('change', () => syncQty(mainQtyInput.value));

  const stickyDecBtn = $('[data-sticky-qty-dec]');
  const stickyIncBtn = $('[data-sticky-qty-inc]');
  if (stickyDecBtn) stickyDecBtn.addEventListener('click', () => syncQty((+stickyQtyInput?.value || 1) - 1));
  if (stickyIncBtn) stickyIncBtn.addEventListener('click', () => syncQty((+stickyQtyInput?.value || 1) + 1));
  if (stickyQtyInput) stickyQtyInput.addEventListener('change', () => syncQty(stickyQtyInput.value));

  // Recompute the cap whenever the user changes a variant. We attach to
  // the radio change event AFTER the existing onVariantChange listener
  // has updated [data-variant-id], so getCurrentVariant() reads the new id.
  // We refresh inCartForVariant from /cart.js on every variant change
  // because a different colour usually has a different in-cart count.
  $$('[data-variant-option]').forEach(input => {
    input.addEventListener('change', () => {
      Promise.resolve().then(refreshInCart);
    });
  });
  // Also recompute after a successful add (cart counts changed).
  document.addEventListener('boni:cart:added', refreshInCart);
  refreshInCart();
  recomputeStockMax();

  // ── Add to cart ───────────────────────────────────────────────────────────

  function showAtcError(msg) {
    let toast = document.querySelector('[data-pdp-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pdp-toast';
      toast.dataset.pdpToast = '';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-visible'), 4000);
  }

  function addToCart(variantId, qty) {
    const btns = $$('[data-atc-btn], [data-sticky-atc]');
    const restore = () => btns.forEach(b => {
      b.disabled = false;
      b.textContent = bfT('add_to_cart', 'In den Warenkorb');
      delete b.dataset.updating;
    });
    btns.forEach(b => { b.dataset.updating = '1'; b.disabled = true; b.textContent = '…'; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(r => r.json().then(body => ({ ok: r.ok, body })))
      .then(({ ok, body }) => {
        if (!ok) {
          // Shopify 422 on over-stock returns {description, message}.
          const msg = (body && (body.description || body.message)) || 'Hinzufügen nicht möglich.';
          showAtcError(msg);
          restore();
          return;
        }
        return fetch('/cart.js').then(r => r.json()).then(cart => {
          document.dispatchEvent(new CustomEvent('boni:cart:added', { detail: cart }));
          btns.forEach(b => { b.textContent = bfT('added', '✓ Hinzugefügt'); });
          setTimeout(restore, 2000);
        });
      })
      .catch(restore);
  }

  const pdpForm = $('[data-pdp-form]');
  if (pdpForm) {
    pdpForm.addEventListener('submit', e => {
      e.preventDefault();
      const fd  = new FormData(pdpForm);
      addToCart(fd.get('id'), parseInt(fd.get('quantity'), 10) || 1);
    });
  }

  const stickyAtc = $('[data-sticky-atc]');
  if (stickyAtc && pdpForm) {
    stickyAtc.addEventListener('click', () => {
      const fd  = new FormData(pdpForm);
      const qty = parseInt(stickyQtyInput?.value || fd.get('quantity'), 10) || 1;
      addToCart(fd.get('id'), qty);
    });
  }

  // ── Sticky bar visibility ─────────────────────────────────────────────────

  const stickyBar = $('[data-sticky-bar]');
  const atcBtn    = $('[data-atc-btn]');

  if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      const outOfView = !entries[0].isIntersecting;
      stickyBar.setAttribute('aria-hidden', String(!outOfView));
      if (outOfView) {
        stickyBar.removeAttribute('inert');
      } else {
        stickyBar.setAttribute('inert', '');
      }
    }, { threshold: 0 });
    io.observe(atcBtn);
  }

  // ── Stock filter ──────────────────────────────────────────────────────────

  $$('[data-stock-filter-input]').forEach(input => {
    const optionDiv = input.closest('.pdp__option');
    const container = optionDiv && optionDiv.querySelector('.pdp__swatches');
    if (!container) return;

    const swatches = Array.from(container.querySelectorAll('.pdp__swatch-label'));

    // Inline empty-state hint
    const hint = document.createElement('p');
    hint.className = 'pdp__filter-empty t-mono';
    hint.hidden = true;
    hint.textContent = bfT('no_color_stock', 'Keine Farbe mit ausreichend Vorrat.');
    container.after(hint);

    function applyFilter() {
      const raw = parseInt(input.value, 10);
      const threshold = Number.isFinite(raw) && raw > 0 ? raw : 0;

      let visibleCount = 0;
      swatches.forEach(sw => {
        const untracked = sw.dataset.untracked === 'true';
        const stock = parseInt(sw.dataset.stock, 10) || 0;
        const passes = threshold === 0 || untracked || stock >= threshold;
        sw.classList.toggle('is-filtered-out', !passes);
        if (passes) visibleCount++;
      });

      hint.hidden = !(threshold > 0 && visibleCount === 0);
    }

    input.addEventListener('input', applyFilter);
  });

  // ── Color-family filter (rainbow slider) ────────────────────────────────────
  // Narrows the swatch grid by `custom.farbe`. The control is a compact rainbow
  // track of family segments (+ an "Alle" reset) you can click OR drag across —
  // it keeps the gap above the swatches small. Uses its own `is-color-filtered`
  // class so it composes with the stock filter (which dims via `is-filtered-out`).

  $$('[data-color-filter]').forEach(group => {
    const optionDiv = group.closest('.pdp__option');
    const container = optionDiv && optionDiv.querySelector('.pdp__swatches');
    if (!container) return;

    const segs = $$('[data-farbe-chip]', group);
    const label = group.querySelector('[data-cfam-label]');
    const swatches = Array.from(container.querySelectorAll('.pdp__swatch-label'));

    function applyFamily(fam) {
      swatches.forEach(sw => {
        const list = (sw.dataset.farbe || '').split(',');
        const show = fam === '*' || list.indexOf(fam) !== -1;
        sw.classList.toggle('is-color-filtered', !show);
      });
    }

    function select(seg) {
      if (!seg) return;
      segs.forEach(s => { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
      seg.classList.add('is-active');
      seg.setAttribute('aria-pressed', 'true');
      if (label) label.textContent = seg.dataset.label || '';
      applyFamily(seg.dataset.farbeChip);
    }

    segs.forEach(seg => seg.addEventListener('click', () => select(seg)));

    // Drag across the rainbow track — live-updates the filter as you slide.
    const track = group.querySelector('[data-cfam-track]');
    if (track) {
      let dragging = false;
      const segAt = (x, y) => {
        const el = document.elementFromPoint(x, y);
        return el && el.closest('[data-farbe-chip]');
      };
      track.addEventListener('pointerdown', e => {
        dragging = true;
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
        select(segAt(e.clientX, e.clientY));
      });
      track.addEventListener('pointermove', e => {
        if (dragging) select(segAt(e.clientX, e.clientY));
      });
      const stop = () => { dragging = false; };
      track.addEventListener('pointerup', stop);
      track.addEventListener('pointercancel', stop);
    }

    // Keyboard: arrows step between segments (incl. the "Alle" reset).
    segs.forEach((seg, i) => {
      seg.addEventListener('keydown', e => {
        let next = null;
        if (e.key === 'ArrowRight') next = segs[Math.min(i + 1, segs.length - 1)];
        else if (e.key === 'ArrowLeft') next = segs[Math.max(i - 1, 0)];
        if (next) { e.preventDefault(); next.focus(); select(next); }
      });
    });
  });

  // ── Swatch thumbnail size toggle ────────────────────────────────────────────
  // Bumps the swatch thumbnails up a size so colorways can be inspected without
  // selecting them. Toggles a class on the .pdp__swatches grid.

  $$('[data-thumb-size]').forEach(btn => {
    const optionDiv = btn.closest('.pdp__option');
    const grid = optionDiv && optionDiv.querySelector('.pdp__swatches');
    if (!grid) return;
    let large = false;
    btn.addEventListener('click', () => {
      large = !large;
      grid.classList.toggle('pdp__swatches--lg', large);
      btn.setAttribute('aria-pressed', String(large));
      btn.textContent = large ? bfT('swatch_smaller', 'Kleiner') : bfT('swatch_bigger', 'Größer');
    });
  });

  // ── Sort toggle ───────────────────────────────────────────────────────────

  $$('[data-sort-toggle]').forEach(btn => {
    const optionDiv = btn.closest('.pdp__option');
    const container = optionDiv && (
      optionDiv.querySelector('.pdp__swatches') ||
      optionDiv.querySelector('.pdp__pills')
    );
    if (!container) return;

    const originalOrder = Array.from(container.children);
    let sorted = false;

    btn.addEventListener('click', () => {
      sorted = !sorted;
      btn.textContent = sorted ? 'Original' : 'A–Z';
      btn.setAttribute('aria-pressed', String(sorted));

      if (sorted) {
        Array.from(container.children)
          .sort((a, b) => {
            const aText = (a.querySelector('.pdp__swatch-name') || a).textContent.trim();
            const bText = (b.querySelector('.pdp__swatch-name') || b).textContent.trim();
            return aText.localeCompare(bText, 'de');
          })
          .forEach(child => container.appendChild(child));
      } else {
        originalOrder.forEach(child => container.appendChild(child));
      }
    });
  });

  // ── Tabs ──────────────────────────────────────────────────────────────────

  const tabList = $('[role="tablist"].pdp-tabs__list');
  if (tabList) {
    const tabs   = $$('[role="tab"]', tabList);
    const panels = $$('.pdp-panel');

    function activateTab(tab) {
      tabs.forEach(t => { t.setAttribute('aria-selected', 'false'); t.classList.remove('is-active'); });
      panels.forEach(p => { p.classList.remove('is-active'); p.hidden = true; });
      tab.setAttribute('aria-selected', 'true');
      tab.classList.add('is-active');
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) { panel.classList.add('is-active'); panel.hidden = false; }
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activateTab(tab));
      tab.addEventListener('keydown', e => {
        let next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft')  next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End')  next = tabs[tabs.length - 1];
        if (next) { next.focus(); activateTab(next); }
      });
    });

    if (tabs[0]) activateTab(tabs[0]);

    // ── Horizontal-scroll affordance for the tab strip ────────────────────
    // Toggle data-overflow-left / data-overflow-right on the wrap so the
    // CSS fade gradients only show on the side that actually has more
    // tabs offscreen. Solves the "no visible scroll hint on mobile" issue.
    const tabsWrap = document.querySelector('[data-pdp-tabs-list-wrap]');
    if (tabsWrap) {
      function updateTabsOverflow() {
        const hasOverflow = tabList.scrollWidth > tabList.clientWidth + 1;
        const atStart = tabList.scrollLeft <= 1;
        const atEnd   = Math.ceil(tabList.scrollLeft + tabList.clientWidth) >= tabList.scrollWidth;
        tabsWrap.setAttribute('data-overflow-left',  hasOverflow && !atStart ? 'true' : 'false');
        tabsWrap.setAttribute('data-overflow-right', hasOverflow && !atEnd   ? 'true' : 'false');
      }
      tabList.addEventListener('scroll', updateTabsOverflow, { passive: true });
      window.addEventListener('resize', updateTabsOverflow);
      updateTabsOverflow();
      // Fonts can load late and shift tab widths; recheck once they settle.
      setTimeout(updateTabsOverflow, 400);

      // First-visit nudge: if tabs overflow, briefly scroll ~28px right
      // and back to demonstrate scrollability. Once per session, opts out
      // of reduced-motion preferences. The scroll-shadow + nudge together
      // give the user a real "ah, this scrolls" moment instead of relying
      // purely on the subtle shadow.
      const NUDGE_KEY = 'bf_tabs_nudged';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let alreadyNudged = false;
      try { alreadyNudged = !!sessionStorage.getItem(NUDGE_KEY); } catch (_) {}
      if (!alreadyNudged && !reducedMotion) {
        setTimeout(() => {
          if (tabList.scrollWidth <= tabList.clientWidth + 1) return; // no overflow → skip
          tabList.scrollTo({ left: 28, behavior: 'smooth' });
          setTimeout(() => tabList.scrollTo({ left: 0, behavior: 'smooth' }), 650);
          try { sessionStorage.setItem(NUDGE_KEY, '1'); } catch (_) {}
        }, 900);
      }
    }
  }

  // ── Back-in-stock notification ────────────────────────────────────────────

  const notifyForm = $('[data-notify-form]');
  if (notifyForm) {
    notifyForm.addEventListener('submit', e => {
      e.preventDefault();
      const fd      = new FormData(notifyForm);
      const email   = fd.get('email');
      const varId   = fd.get('variant_id');
      const title   = fd.get('product_title');
      const url     = fd.get('product_url');
      const imgUrl  = fd.get('product_image');
      if (!email) return;

      const learnq = window._learnq || [];
      learnq.push(['identify', { '$email': email }]);
      learnq.push(['track', 'Subscribed to Back in Stock', {
        ProductName: title,
        VariantId: varId,
        ProductURL: url,
        ImageURL: imgUrl
      }]);

      const successEl = $('[data-notify-success]');
      notifyForm.hidden = true;
      if (successEl) successEl.hidden = false;
    });
  }

  // ── Inline Mengenrechner ──────────────────────────────────────────────────

  const mrSection = $('[data-pdp-mengenrechner]');
  if (mrSection) {
    const yarnMeters = parseFloat(mrSection.dataset.yarnMeters) || 0;
    const yarnGrams  = parseFloat(mrSection.dataset.yarnGrams)  || 100;
    const projectSel = $('[data-mr-project]', mrSection);
    const sizeSel    = $('[data-mr-size]', mrSection);
    const sizeWrap   = $('[data-mr-size-wrap]', mrSection);
    const resultEl   = $('[data-mr-result]', mrSection);
    const ballsEl    = $('[data-mr-balls]', mrSection);
    const gramsEl    = $('[data-mr-grams]', mrSection);
    const metersEl   = $('[data-mr-meters]', mrSection);
    const wcEl       = $('[data-mr-weight-class]', mrSection);

    const mPer100g = yarnGrams > 0 ? (yarnMeters * 100 / yarnGrams) : 0;

    function weightClass(m) {
      if (!m) return '';
      if (m > 600) return 'Lace';
      if (m >= 380) return 'Fingering';
      if (m >= 280) return 'Sport';
      if (m >= 200) return 'DK';
      if (m >= 150) return 'Worsted';
      if (m >= 110) return 'Aran';
      if (m >= 75)  return 'Bulky';
      if (m >= 50)  return 'Super Bulky';
      return 'Jumbo';
    }
    if (wcEl) wcEl.textContent = weightClass(mPer100g);

    const dataUrl = mrSection.dataset.mrDataUrl
      || document.documentElement.dataset.mrDataUrl
      || '/cdn/shop/t/1/assets/mengenrechner-data.json';

    fetch(dataUrl)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .catch(() => ({ project_types: [] }))
      .then(data => {
        if (!data.project_types.length) return;

        data.project_types.forEach(pt => {
          const opt = document.createElement('option');
          opt.value = pt.id;
          opt.textContent = pt.label;
          projectSel.appendChild(opt);
        });

        function calculate() {
          const gramsNeeded = parseFloat(sizeSel.value) || 0;
          if (!gramsNeeded || !yarnGrams || !mPer100g) { resultEl.hidden = true; return; }
          const balls  = Math.ceil(gramsNeeded / yarnGrams);
          const grams  = balls * yarnGrams;
          const meters = Math.round(grams * mPer100g / 100);
          if (ballsEl)  ballsEl.textContent  = balls;
          if (gramsEl)  gramsEl.textContent  = grams;
          if (metersEl) metersEl.textContent = meters;
          resultEl.hidden = false;
        }

        projectSel.addEventListener('change', () => {
          const pt = data.project_types.find(p => p.id === projectSel.value);
          sizeSel.innerHTML = '';
          if (!pt) { sizeWrap.hidden = true; resultEl.hidden = true; return; }
          pt.sizes.forEach(sz => {
            const opt = document.createElement('option');
            opt.value = sz.grams;
            opt.textContent = sz.label;
            sizeSel.appendChild(opt);
          });
          sizeWrap.hidden = pt.sizes.length <= 1;
          calculate();
        });

        sizeSel.addEventListener('change', calculate);
      });
  }

})();
